/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ region: NonNullable<unknown> }} Coach_Context_Injury_HistoryInputs */

const en_us2_coach_context_injury_history = /** @type {(inputs: Coach_Context_Injury_HistoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: past injury`)
};

const pt_br2_coach_context_injury_history = /** @type {(inputs: Coach_Context_Injury_HistoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: lesão antiga`)
};

const es_419_coach_context_injury_history = /** @type {(inputs: Coach_Context_Injury_HistoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: lesión pasada`)
};

const pt_pt2_coach_context_injury_history = /** @type {(inputs: Coach_Context_Injury_HistoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: lesão antiga`)
};

const fr_fr2_coach_context_injury_history = /** @type {(inputs: Coach_Context_Injury_HistoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region} : ancienne blessure`)
};

const de_de2_coach_context_injury_history = /** @type {(inputs: Coach_Context_Injury_HistoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: frühere Verletzung`)
};

const it_it2_coach_context_injury_history = /** @type {(inputs: Coach_Context_Injury_HistoryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.region}: infortunio passato`)
};

/**
* | output |
* | --- |
* | "{region}: past injury" |
*
* @param {Coach_Context_Injury_HistoryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_context_injury_history = /** @type {((inputs: Coach_Context_Injury_HistoryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Context_Injury_HistoryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_context_injury_history(inputs)
	if (locale === "es-419") return es_419_coach_context_injury_history(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_context_injury_history(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_context_injury_history(inputs)
	if (locale === "de-DE") return de_de2_coach_context_injury_history(inputs)
	if (locale === "it-IT") return it_it2_coach_context_injury_history(inputs)
	return en_us2_coach_context_injury_history(inputs)
});
export { coach_context_injury_history as "coach.context_injury_history" }